import { ActivatedRoute } from '@angular/router';
import { Component, Inject, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { NavService } from '../nav/service/nav.service';
import { Title, Meta } from '@angular/platform-browser';
import { MetaService } from '../shared/services/meta.service';

@Component({
  selector: 'app-legal-notice',
  templateUrl: './legal-notice.component.html',
  styleUrls: ['./legal-notice.component.scss'],
  standalone: true,
})
export class LegalNoticeComponent implements OnInit {
  private readonly metaTagService = inject(MetaService);

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private navService: NavService,
    route: ActivatedRoute,
    titleService: Title,
    metaTagService: Meta
  ) {
    if (route.snapshot.data && route.snapshot.data['name']) {
      titleService.setTitle(route.snapshot.data['title']);

      this.metaTagService.updateMetaTags(
        `Mentions légales`,
        `Mentions légales`,
        'https://lesexplorateursdumonde.com/legal-notice',
        'website'
      );

      metaTagService.removeTag('property="og:image"');
      metaTagService.removeTag('property="og:image:width"');
      metaTagService.removeTag('property="og:image:height"');
      metaTagService.removeTag('property="og:image:type"');
    }
  }

  ngOnInit(): void {
    this.navService.setGreenBackground();
  }
}
